import { combineI18nMessages, defaultMessagesEN } from "@duosoftbg/bpo-components";
import validationKeysEN from "./slices/validationKey/validationKeysEN";
import { ObjectType, RegisterType } from "../../utils/constants";
import {
  CpcSearchType,
  IpcSearchType,
  PublicationSearchType,
  RepresentativeSearchType,
} from "../../types/registers/search/filter/filterTypes";

const messagesEn = combineI18nMessages(defaultMessagesEN, {
  translation: {
    "t.page.registers": "Electronic registers",
    "t.page.marksSearch": "Marks search",
    "t.page.patentsSearch": "Patents search",
    "t.page.geoIndicationsSearch": "Geo indications search",
    "t.page.combinedSearch": "Combined search",
    "t.page.agentSearch": "Representatives of industrial property search",
    "t.page.partnershipSearch": "IPR Associations/Companies search",
    "t.page.partnershipView": "IPR Association/Company details",
    "t.page.agentView": "Agent details",
    "t.page.decisionsSearch": "Decisions",
    "t.page.europeanPatentsSearch": "European patents search",
    "t.page.utilityModelsSearch": "Utility models search",
    "t.page.spcsSearch": "SPCs search",
    "t.page.agentsSearch": "Representatives of industrial property",
    "t.page.plantsBreedsSearch": "Plants and breeds search",
    "t.page.designsSearch": "Designs search",
    "t.page.externalDetailView": "Object view page",
    "t.page.topologySearch": "Integral schema topologies",
    "t.topologies": "Topologies",
    "t.eRegisters": "Electronic registers",
    "t.combineSearch": "Combined search",
    "t.modal.searchFilters.marks": "Search criteria for marks",
    "t.modal.searchFilters.geoIndications": "Search criteria for geo indications",
    "t.modal.searchFilters.combineSearch": "Combine search criteria",
    "t.modal.searchFilters.agents": "Search criteria for representatives",
    "t.modal.searchFilters.partnerships": "Search criteria for IPR Associations/Companies",
    "t.modal.searchFilters.decisions": "Search criteria for decisions",
    "t.modal.searchFilters.instruction": "Please select relevant search criteria",
    "t.modal.searchFilters.combineSearch.instruction": "Combine search criteria",
    "t.modal.searchFilters.patents": "Search criteria for patents",
    "t.modal.searchFilters.europeanPatents": "Search criteria for European patents",
    "t.modal.searchFilters.utilityModels": "Search criteria for utility models",
    "t.modal.searchFilters.spcs": "Search criteria for SPC",
    "t.modal.searchFilters.plantsBreeds": "Search criteria for plants/breeds",
    "t.modal.searchFilters.designs": "Search criteria for designs",
    "t.panel.mainInfo": "Information",
    // [`t.panel.mainInfo.${VIEW_TYPES.MARK}`]: "Mark information",
    // [`t.panel.mainInfo.${VIEW_TYPES.GEO_INDICATION}`]: "Geo indication information",
    "t.panel.connectedObjects": "Other IP objects",
    "t.panel.niceClasses": "Nice classes",
    "t.panel.viennaClasses": "Vienna classes",
    "t.panel.persons": "Persons and contacts",
    "t.panel.priorities": "Priorities",
    "t.panel.publications": "Publications",
    "t.panel.history": "History of changes",
    "t.panel.partnerships": "Partnerships/Companies",
    "t.panel.agents": "Registered representatives",
    "t.page.object": "Object",
    "m.hideSearchCriteria": "Hide search criteria",
    "m.showSearchCriteria": "Show search criteria",
    "m.resetFilters.success": "Reset operation has finished successfully!",
    "m.submitFilters.success": "Search operation has finished successfully!",
    "m.alert.pleaseEnterValidSearchCriteria": "Please review and fix validation errors related to search filters",
    "m.registers.marks.desc":
      "The electronic register for marks gives opportunity for search and views of nationality marks",
    "m.registers.nationalPatents.desc":
      "The electronic register for patents gives opportunity for search and views of nationality patents",
    "m.registers.geoIndications.desc":
      "The electronic register for geographical indications gives opportunity for search and views of geographical indications",
    "m.registers.epoPatents.desc":
      "The electronic register for european patents gives opportunity for search and views of european patents",
    "m.registers.utilityModels.desc":
      "The electronic register for utility models gives opportunity for search and views of utility models",
    "m.registers.plantsBreeds.desc":
      "The electronic register for plants and breeds gives opportunity for search and views of plants and breeds",
    "m.registers.spc.desc": "The electronic register for SPCs gives opportunity for search and views of SPCs",
    "m.registers.designs.desc": "The electronic register for designs gives opportunity for search and views of designs",
    "m.registers.agents.desc":
      "The electronic register for representatives gives opportunity for search and views of representatives",
    "m.registers.associations.desc":
      "The electronic register for associations/partnerships gives opportunity for search and views of associations/partnerships",
    "m.registers.decisions.desc": "Electronic register for decisions",
    "m.registers.combineSearch.desc": "Combined search",
    "m.errorMessage.successReport": "Successfully reported Error in current object",
    "l.searchFilter.name": "Name",
    "l.searchFilter.single.design.name": "(54) Product name",
    "l.searchFilter.single.design.verbal.element": "Verbal element",
    [`l.searchFilter.name.${RegisterType.DESIGN}`]: "Common request designs name",
    [`l.searchFilter.name.${RegisterType.PATENT}`]: "(54) Name",
    [`l.searchFilter.name.${RegisterType.SPC}`]: "(54) Main patent title",
    [`l.searchFilter.name.${RegisterType.MARK}`]: "(541) Name",
    "l.searchFilter.objectRange": "Scope of search",
    // [`l.searchFilter.name.${SEARCH_FILTERS_GROUP.AGENTS}`]: "Representative name",
    "l.searchFilter.nameExactMatch": "Name",
    // [`l.searchFilter.nameExactMatch.${SEARCH_FILTERS_GROUP.MARKS}`]: "Mark name",
    // [`l.searchFilter.nameExactMatch.${SEARCH_FILTERS_GROUP.GEO_INDICATIONS}`]: "Geo indication name",
    // [`l.searchFilter.nameExactMatch.${SEARCH_FILTERS_GROUP.PATENTS}`]: "Patent name",
    // [`l.searchFilter.nameExactMatch.${SEARCH_FILTERS_GROUP.DESIGNS}`]: "Design name",
    "l.searchFilter.markKind": "(550) Mark kind",
    // [`l.searchFilter.markKind.${SEARCH_FILTERS_GROUP.GEO_INDICATIONS}`]: "Geo indication kind",
    "l.searchFilter.objectSubType": "Object type",
    [`l.searchFilter.objectSubType.${RegisterType.GEO_INDICATION}`]: "(551) Geo indication type",
    [`l.searchFilter.objectSubType.${RegisterType.MARK}`]: "(551) Mark type",
    "l.searchFilter.filingNumber": "Filing number",
    [`l.searchFilter.filingNumber.${RegisterType.MARK}`]: "(210) Filing number",
    [`l.searchFilter.filingNumber.${RegisterType.PATENT}`]: "(21) Filing number",
    [`l.searchFilter.filingNumber.${RegisterType.EU_PATENT}`]: "(96) Filing number",
    "l.searchFilter.filingDate": "Filing date",
    [`l.searchFilter.filingDate.${RegisterType.MARK}`]: "(220) Filing date",
    [`l.searchFilter.filingDate.${RegisterType.PATENT}`]: "(22) Filing date",
    [`l.searchFilter.filingDate.${RegisterType.EU_PATENT}`]: "(96) Filing date",
    "l.searchFilter.registrationDate": "RegistrationDate",
    "l.searchFilter.registrationNumber": "Registration number",
    [`l.searchFilter.registrationNumber.${RegisterType.MARK}`]: "(111) Registration number",
    [`l.searchFilter.registrationNumber.${RegisterType.DESIGN}`]: "(11) Registration number",
    "l.searchFilter.protectedNumber": "Protected number",
    [`l.searchFilter.protectedNumber.${RegisterType.PATENT}`]: "(11) Protected number",
    "l.searchFilter.expirationDate": "Expiration date",
    [`l.searchFilter.expirationDate.${RegisterType.MARK}`]: "(181) Expiration date",
    [`l.searchFilter.expirationDate.${RegisterType.PATENT}`]: "(94) Expiration date",
    [`l.searchFilter.expirationDate.${RegisterType.DESIGN}`]: "(17) Expiration date",
    "l.searchFilter.niceClasses": "(511) Classes of goods/services",
    "l.searchFilter.niceClasses.specification": "Specifications",
    "l.searchFilter.viennaClasses": "(531) Vienna classes",
    "l.searchFilter.status": "Status",
    "l.searchFilter.publications": "Publications",
    [`l.searchFilter.publications.${RegisterType.MARK}`]: "(442) Publications",
    [`l.searchFilter.publications.${RegisterType.PATENT}`]: "(41) Publications",
    [`l.searchFilter.publications.${RegisterType.EU_PATENT}`]: "(97) Publications",
    "l.searchFilter.publicationYear": "Publication year",
    "l.searchFilter.publicationNumber": "Publication number",
    "l.searchFilter.publicationSection": "Publication section",
    "l.searchFilter.publicationDate": "Publication date",
    "l.searchFilter.publicationSearchType": "Search type",
    [`l.searchFilter.publicationSearchType.${PublicationSearchType.JOURNAL_NBR}`]: "By journal number",
    [`l.searchFilter.publicationSearchType.${PublicationSearchType.PUBLICATION_DATE}`]: "By publication date",
    "l.searchFilter.priorityDate": "Priority date",
    "l.searchFilter.country": "Country",
    "l.searchFilter.number": "Number",
    "l.searchFilter.representative": "Representative",
    [`l.searchFilter.representative.${RegisterType.MARK}`]: "(740) Representative",
    [`l.searchFilter.representative.${RegisterType.PATENT}`]: "(74) Representative",
    "l.searchFilter.representativeTypeCode": "Representative type",
    "l.searchFilter.representative.code.or.name": "Наименование / Номер на ПИС(Съдружие)",
    "l.searchFilter.representative.name": "Representative",
    "l.searchFilter.exactMatch": "Exact match",
    "l.searchFilter.representativeName.exactMatch": "Exact match",
    "l.searchFilter.representativeName.wholeWords": "Search by whole words",
    "l.searchFilter.representativeName.freeSearch": "Free search",
    "l.searchFilter.viennaClasses.allSelected": "ALL listed classes",
    "l.searchFilter.viennaClasses.withoutSelected": "Without the listed classes",
    "l.searchFilter.viennaClasses.someSelected": "Some of listed classes",
    "l.searchFilter.ipoArea": "Objects of Industrial Property",
    "l.searchFilter.decisionObjectType": "Object type",
    "l.searchFilter.decisionGroundType": "Legal ground type",
    "l.searchFilter.decisionType": "Decision type",
    "l.searchFilter.decisionNumber": "Decision number",
    "l.searchFilter.decisionDate": "Decision date",
    "l.table.head.partnershipName": "Name",
    "l.table.head.representativeType": "Type",
    "l.searchFilter.agentCode": "Number",
    "l.searchFilter.agentSpeciality": "Speciality",
    "l.searchFilter.city": "City",
    "l.searchFilter.abstract": "Abstract",
    [`l.searchFilter.abstract.${RegisterType.PATENT}`]: "(57) Abstract",
    [`l.searchFilter.abstract.${RegisterType.UTILITY_MODEL}`]: "(57) Abstract",
    [`l.searchFilter.abstract.${RegisterType.EU_PATENT}`]: "(57) Abstract",
    [`l.searchFilter.abstract.${RegisterType.SPC}`]: "(95) Product name",
    "l.searchFilter.origin": "Origin",
    "l.searchFilter.agentName": "Name",
    "l.searchFilter.abstract.hint": "Search with multiple words works with (;). Example: car;train",
    "l.searchFilter.priority": "Priority",
    [`l.searchFilter.priority.${RegisterType.PATENT}`]: "(31, 32, 33) Priority",
    [`l.searchFilter.priority.${RegisterType.MARK}`]: "(310, 320, 330) Priority",
    "l.searchFilter.priorityDateFrom": "Priority date from",
    "l.searchFilter.priorityDateTo": "Priority date to",
    "l.searchFilter.priorityCountry": "Priority country",
    "l.searchFilter.priorityNumber": "Priority number",
    "l.searchFilter.locarnoClasses": "(51) Locarno classification",
    "l.searchFilter.locarnoClass": "Locarno class",
    "l.searchFilter.locarnoSubclass": "Locarno subclass",
    "l.mark": "Mark",
    "l.gi": "Geographical indication",
    "l.agent": "Representative",
    "l.agent.address": "Representative address",
    "l.partnership": "IPR Association/Company",
    "l.table.head.agentName": "Name",
    "l.table.head.agentCode": "Number",
    "l.table.head.ipoArea": "Objects of Industrial Property",
    "l.table.head.agentSpeciality": "Speciality",
    "l.table.head.city": "City",
    "l.table.head.participants": "Participants",
    "l.table.head.recordalNumber": "Reference number",
    "l.table.head.recordalType": "Recordal type",
    "l.table.head.opposition.recordalType": "Request type",
    "l.table.head.cancellation.recordalType": "Request type",
    "l.table.head.opponent": "Opponent",
    "l.table.head.claimant": "Claimant",
    "l.table.head.status": "Status",
    "l.table.head.decision": "decision",
    "l.table.head.decision.docType": "Document type",
    "l.table.head.decision.docNumber": "Document number",
    "l.table.head.decision.docDate": "Document date",
    "l.table.head.decision.link": "Download link",
    "l.panel.objectDecisionsData": "Decisions",
    "l.table.head.recordalDate": "Recordal date",
    "l.table.head.recordalDate.empty": "Entered",
    "l.table.head.invalidationDate": "Invalidation date",
    "l.heading.address": "Address",
    "l.searchFilter.patentName": "Name/Title",
    "l.searchFilter.ipcClass": "(51) IPC",
    "l.searchFilter.cpcClass": "(52) CPC",
    "l.searchFilter.latinClassification": "Latin classification",
    "l.searchFilter.bgClassification": "BG classification",
    "l.searchFilter.inventor": "Inventor",
    [`l.searchFilter.inventor.${RegisterType.PATENT}`]: "(72) Inventor",
    "l.searchFilter.author": "Author",
    [`l.searchFilter.author.${RegisterType.DESIGN}`]: "(72) Author",
    // [`l.searchFilter.inventor.${SEARCH_FILTERS_GROUP.DESIGNS}`]: "Author",
    "l.searchFilter.inventor.personSelect": "Search by person select",
    "l.searchFilter.applicantOwner": "Applicant/Owner",
    [`l.searchFilter.applicantOwner.${RegisterType.MARK}`]: "(731, 732) Applicant/Owner",
    [`l.searchFilter.applicantOwner.${RegisterType.GEO_INDICATION}`]: "(731, 732) Applicant/Owner",
    [`l.searchFilter.applicantOwner.${RegisterType.PATENT}`]: "(71) Applicant/Owner",
    "l.searchFilter.applicantOwner.personSelect": "Search by person select",
    "l.searchFilter.representativeTypes": "Representative type",
    "l.searchFilter.representativeSearchType": "Kind of search by representative",
    [`l.searchFilter.representativeSearchType.${RepresentativeSearchType.TEXT}`]:
      "Search by representative name (free text)",
    [`l.searchFilter.representativeSearchType.${RepresentativeSearchType.AUTOCOMPLETE}`]:
      "Search by selecting representatives from list",
    "l.searchFilter.representatives": "Selected representatives",
    "l.patent": "Patent",
    "l.europeanPatent": "European patent",
    "l.utilityModel": "Utility model",
    "l.spc": "SPC",
    "l.plantBreed": "Plant/Breed",
    "l.design": "Design",
    "l.table.head.decisionNumber": "Decision number",
    "l.table.head.decisionDate": "Decision date",
    "l.detail.agentName": "Name",
    [`l.detail.agentName.${RegisterType.AGENT}`]: "Representative Name",
    [`l.detail.agentName.${RegisterType.PARTNERSHIP}`]: "Name",
    "l.detail.agentType": "Type",
    "l.detail.ipoArea": "Objects of Industrial Property",
    "l.detail.certification.country": "Country of certification",
    "l.detail.origin.country": "Country of origin",
    [`l.detail.origin.country.${RegisterType.AGENT}`]: "Citizenship",
    [`l.detail.origin.country.${RegisterType.PARTNERSHIP}`]: "Country of origin",
    "l.detail.citizenship": "Citizenship",
    "l.detail.speciality": "Speciality",
    "l.detail.official.address": "Official address",
    [`l.detail.official.address.${RegisterType.AGENT}`]: "Official address",
    [`l.detail.official.address.${RegisterType.PARTNERSHIP}`]: "Management address",
    "l.detail.ca.address": "Correspondence address",
    "l.detail.partnershipName": "Name",
    "l.detail.partnershipCode": "Number",
    "l.detail.ipoArea.short": "Objects of IP",
    "l.detail.partnershipType": "Type",
    "l.detail.agentCode": "Number",
    "l.detail.agentNameEn": "Name (English)",
    [`l.detail.agentNameEn.${RegisterType.AGENT}`]: "Representative name (English)",
    [`l.detail.agentNameEn.${RegisterType.PARTNERSHIP}`]: "Name (English)",
    "l.detail.official.addressEn": "Official address (English)",
    // [`l.detail.official.addressEn.${VIEW_TYPES.AGENT}`]: "Official address (English)",
    // [`l.detail.official.addressEn.${VIEW_TYPES.PARTNERSHIP}`]: "Management address (English)",
    "l.detail.ca.addressEn": "Correspondence address (English)",
    "l.detail.specialityEn": "Speciality (English)",
    "l.detail.status": "Status",
    "l.detail.partnership.participants": "Participants",
    "l.text.search.type.CONTAINS_WORDS": "Free match",
    "l.text.search.type.WHOLE_WORDS": "Whole word match",
    "l.text.search.type.EXACTLY": "Exact match",
    "l.search.operator.type.AND": "ALL listed",
    "l.search.operator.type.OR": "SOME of listed",
    "l.search.operator.type.AND_NOT": "WITHOUT the listed",
    "l.select.nice.classes.btn": "Select classes of goods/services",
    "l.btn.confirm": "Confirm",
    "l.description": "Description",
    "l.niceClasses": "Classes of goods/services",
    "l.operator.search.type.AND": "All of the selected",
    "l.operator.search.type.OR": "Some of the selected",
    "l.operator.search.type.AND_NOT": "None of the selected",
    "l.name": "Name",
    "l.objectId": "Filing number",
    "l.title": "Title",
    [`l.title.${RegisterType.DESIGN}`]: "Common name",
    [`l.title.${RegisterType.SPC}`]: "Main patent title",
    "l.filingDate": "Filing date",
    "l.agentSpeciality": "Speciality",
    "l.representativeType": "Type",
    "l.ipoArea": "Objects of Industrial Property",
    "l.agentStatus": "Status",
    "l.agentName": "Name",
    "l.agentCode": "Number",
    "l.btn.expand.all": "Expand all",
    "l.btn.collapse.all": "Collapse all",
    "l.btn.address": "Address",
    "l.date.format": "dd.MM.yyyy",
    "t.history.new.record": "Registration : ",
    "t.history.change.address": "Edit name or address : ",
    "t.history.renewed": "Re-entry : ",
    "t.history.change.active": "Change on entry : ",
    "t.history.invalidated": "Deletion : ",
    "t.history.temp.invalidated": "Suspension : ",
    "l.panel.no.data": "No data found",
    "l.panel.agentMainData": "Representative's data",
    "l.panel.partnershipMainData": "Partnership/Company details",
    "l.panel.partnershipAgents": "Registered representatives",
    "l.panel.agentPartnerships": "Included in the following partnerships/companies",
    "l.panel.patentLikeMainData": "Patent details",
    "l.panel.singleDesignsData": "Single designs",
    "l.panel.patentLikeAbstractData": "(57) Abstract",
    "l.spcAbstractData": "(95) Product name",
    "l.panel.plantBreedAbstractData": "Information origin, maintenance and reproduction",
    "l.panel.patentLikeIpcData": "(51) IPC",
    "l.panel.patentLikeCpcData": "(52) CPC",
    "l.panel.patentLikeApplicantOwnerData": "(71) Applicants/Owners",
    "l.panel.patentLikeInventorData": "(72) Inventors",
    "l.panel.designAuthorData": "(72) Authors",
    "l.panel.plantBreedAuthorData": "(72) Authors",
    "l.panel.representativeData": "(74) Representatives",
    [`l.panel.representativeData.${RegisterType.MARK}`]: "(740) Representatives",
    [`l.panel.representativeData.${RegisterType.GEO_INDICATION}`]: "(740) Representatives",
    "l.panel.priorityData": "Priorities",
    [`l.panel.priorityData.${RegisterType.MARK}`]: "(310, 320, 330) Priorities",
    [`l.panel.priorityData.${RegisterType.GEO_INDICATION}`]: "(310, 320, 330) Priorities",
    [`l.panel.priorityData.${RegisterType.PATENT}`]: "(31, 32, 33) Priorities",
    [`l.panel.priorityData.${RegisterType.UTILITY_MODEL}`]: "(31, 32, 33) Priorities",
    [`l.panel.priorityData.${RegisterType.EU_PATENT}`]: "(31, 32, 33) Priorities",
    [`l.panel.priorityData.${RegisterType.SPC}`]: "(31, 32, 33) Priorities",
    [`l.panel.priorityData.${RegisterType.DESIGN}`]: "(31, 32, 33) Priorities",
    "l.panel.publicationData": "(41) Publications",
    [`l.panel.publicationData.${RegisterType.MARK}`]: "(442) Publications",
    [`l.panel.publicationData.${RegisterType.GEO_INDICATION}`]: "(442) Publications",
    [`l.panel.publicationData.${RegisterType.EU_PATENT}`]: "(97) Publications",
    "l.panel.taxonData": "Latin classification",
    "t.page.patentsView": "Patent details",
    "t.page.designsView": "Design details",
    "t.page.euPatentsView": "European patent details",
    "t.page.plantsBreedsView": "Plant/Breed details",
    "t.page.spcsView": "SPC details",
    "t.page.utilityModelsView": "Utility model details",
    "t.page.decisionsView": "Legal decision details",
    "l.object.title": "(54) Title",
    [`l.object.title.${RegisterType.SPC}`]: "(54) Main patent title",
    [`l.object.title.${RegisterType.GEO_INDICATION}`]: "(541) Title",
    [`l.object.title.${RegisterType.DESIGN}`]: "Common request designs name",
    "l.object.titleEn": "Title in English",
    [`l.object.titleEn.${RegisterType.DESIGN}`]: "Common request designs name in English",
    "l.object.subtype": "Object subtype",
    "l.object.applicationNumber": "(21) Application number",
    [`l.object.applicationNumber.${RegisterType.MARK}`]: "(210) Application number",
    [`l.object.applicationNumber.${RegisterType.GEO_INDICATION}`]: "(210) Application number",
    [`l.object.applicationNumber.${RegisterType.EU_PATENT}`]: "(96) Application number",
    "l.object.filingDate": "(22) Application date",
    [`l.object.filingDate.${RegisterType.MARK}`]: "(220) Application date",
    [`l.object.filingDate.${RegisterType.GEO_INDICATION}`]: "(220) Application date",
    [`l.object.filingDate.${RegisterType.EU_PATENT}`]: "(96) Application date",
    "l.object.registrationNumber.col": "Protection number",
    "l.object.registrationNumber": "(11) Protection number",
    [`l.object.registrationNumber.${RegisterType.MARK}`]: "(111) Registration number",
    [`l.object.registrationNumber.${RegisterType.GEO_INDICATION}`]: "(111) Registration number",
    [`l.object.registrationNumber.${RegisterType.DESIGN}`]: "(11) Registration number",
    "l.object.registrationDate": "(24) Issue/Registration date",
    [`l.object.registrationDate.${RegisterType.MARK}`]: "(151) Registration date",
    [`l.object.registrationDate.${RegisterType.GEO_INDICATION}`]: "(151) Registration date",
    [`l.object.registrationDate.${RegisterType.DESIGN}`]: "(15) Registration date",
    "l.object.expirationDate": "(94) Expiry date",
    [`l.object.expirationDate.${RegisterType.MARK}`]: "(181) Expiry date",
    [`l.object.expirationDate.${RegisterType.GEO_INDICATION}`]: "(181) Expiry date",
    [`l.object.expirationDate.${RegisterType.DESIGN}`]: "(17) Expiry date",
    "l.object.mainOwner": "Applicant/Owner",
    [`l.object.mainOwner.${RegisterType.MARK}`]: "(731, 732) Applicant/Owner",
    [`l.object.mainOwner.${RegisterType.GEO_INDICATION}`]: "(731, 732) Applicant/Owner",
    "l.object.status": "Status",
    "l.object.lastPaidYear": "Latest annual fee paid",
    "l.object.paymentDate": "Last paid",
    "l.object.renewalFeesPaidTo": "Fees paid to",
    "l.object.notInForceDate": "Termination/Cancellation date",
    "l.object.viennaClasses": "Vienna classes",
    "l.object.locarnoClasses": "Locarno classes",
    "l.object.mark.objectSubType": "Mark type",
    "l.person.name": "Name",
    "l.person.nationality": "Nationality",
    "l.person.address": "Address",
    "l.priority.country": "(33) Country",
    [`l.priority.country.${RegisterType.MARK}`]: "(330) Country",
    [`l.priority.country.${RegisterType.GEO_INDICATION}`]: "(330) Country",
    "l.priority.date": "(32) Date",
    [`l.priority.date.${RegisterType.MARK}`]: "(320) Date",
    [`l.priority.date.${RegisterType.GEO_INDICATION}`]: "(320) Date",
    "l.priority.number": "(31) Number",
    [`l.priority.number.${RegisterType.MARK}`]: "(310) Number",
    [`l.priority.number.${RegisterType.GEO_INDICATION}`]: "(310) Number",
    "l.publication.journal": "Journal",
    [`l.publication.journal.${RegisterType.MARK}`]: "(442) Journal",
    [`l.publication.journal.${RegisterType.GEO_INDICATION}`]: "(442) Journal",
    "l.publication.date": "Publication date",
    "l.publication.section": "Section",
    "l.taxon.taxonCode": "Taxon",
    "l.taxon.commonClassifyBg": "BG classification",
    "l.taxon.latinClassify": "Latin classification",
    [`l.application.${RegisterType.PATENT}`]: "Patent application",
    [`l.application.${RegisterType.DESIGN}`]: "Design application",
    [`l.application.${RegisterType.EU_PATENT}`]: "European patent application",
    [`l.application.${RegisterType.UTILITY_MODEL}`]: "Utility model application",
    [`l.application.${RegisterType.SPC}`]: "SPC application",
    [`l.application.${RegisterType.PLANT_BREED}`]: "Plant/Breed application",
    "l.reference.to": "Reference to",
    "l.panel.relatedObjects": "Other IP objects",
    "l.related.object.relationshipType": "Type",
    "l.related.object.description": "Description",
    [`l.related.object.description.${RegisterType.MARK}`]: "(646) Description",
    "l.related.object.link": "Access link",
    "l.panel.patentLikeCitations": "Citations",
    "l.citation.refNbr": "Reference number",
    "l.citation.refClaims": "Reference claims",
    "l.citation.refDescription": "Reference description",
    "l.panel.patentLikeAttachmentsData": "(57) Descriptions and claims",
    "l.attachment.attachmentType": "Document type",
    "l.attachment.fileName": "File name",
    "l.attachment.download": "Download link",
    "l.panel.plantAttachmentsData": "Images",
    "l.panel.recordalData": "Recordals",
    [`l.panel.recordalData.${RegisterType.MARK}`]: "(580) Recordals",
    [`l.panel.recordalData.${RegisterType.GEO_INDICATION}`]: "(580) Recordals",
    "l.panel.oppositionData": "Opposition/Objections",
    "l.panel.cancellationData": "Request for cancellation/deletion of registration",
    "l.recordal.number": "Reference number",
    "l.recordal.type": "Type of change",
    "l.recordal.requestDate": "Date of entry",
    "l.recordal.invalidationDate": "Invalidation date",
    "t.page.marksView": "Trademark details",
    [`l.application.${RegisterType.MARK}`]: "Trademark application",
    "l.panel.markMainData": "Trademark details",
    "l.panel.markAttachmentsData": "Other files",
    "l.panel.markApplicantOwnerData": "(731, 732) Applicant/Owner",
    "l.object.disclaimer": "(526) Disclaimer",
    "l.object.markKind": "(550) Kind",
    "l.object.markType": "(551) Type",
    "l.object.image": "View",
    "l.registrationNumber": "Registration number",
    "l.panel.drawingsData": "Images",
    [`l.panel.drawingsData.${RegisterType.MARK}`]: "(540/541/554/556) Representation",
    [`l.panel.drawingsData.${RegisterType.GEO_INDICATION}`]: "(540/541/554/556) Representation",
    "l.panel.coloursData": "(591) Claimed colour(s)",
    "l.panel.viennaClassesData": "(531) Vienna classification",
    "l.panel.niceClassesData": "(511) Nice classification",
    "l.panel.geoMainData": "Geographical indication details",
    "t.page.geoIndicationsView": "Geographical indication details",
    [`l.application.${RegisterType.GEO_INDICATION}`]: "Geographical indication application",
    "l.related.object.additional.data": "Additional data",
    "l.related.object.registration.number": "Registration number",
    "l.related.object.priority.date": "Priority date",
    "l.object.acquired.distinctiveness": "Acquired distinctiveness",
    "l.yes": "Yes",
    "l.no": "No",
    "l.according.representation": "According to representation",
    "l.panel.descriptionData": "Description",
    "l.no.declared": "None declared",
    "l.word.elements": "(541) Text elements",
    "l.mark.image.inid.code": "(540)",
    "l.mark.image.inid.code.AUDIO": "(556)",
    "l.mark.image.inid.code.VIDEO": "(540)",
    "l.mark.image.inid.code.IMAGE": "(540)",
    "l.markKind": "Mark kind",
    "l.btn.saveResultPdf": "Save as PDF",
    "l.btn.saveResultExcel": "Save as Excel",
    "l.btn.saveResultDocx": "Save as Docx",
    "l.btn.saveResultFile": "Save",
    "l.display.pdf": "Display PDF",
    "l.person.related.objects": "Other IP objects",
    "l.table.head.objectId": "Object",
    "l.table.head.role": "Role",
    "l.view.related.objects": "Check other IP objects",
    "m.warning.person.duplicates":
      "It is possible that the person exists with different spellings of the name, so the results may be incomplete.",
    "m.error.load.media": "An error occurred while loading the media",
    [`l.title.docx.${RegisterType.MARK}`]: "Trademark reference",
    [`l.title.docx.${RegisterType.PATENT}`]: "National patent reference",
    [`l.title.docx.${RegisterType.EU_PATENT}`]: "EU patent reference",
    [`l.title.docx.${RegisterType.GEO_INDICATION}`]: "Geographical indication reference",
    [`l.title.docx.${RegisterType.UTILITY_MODEL}`]: "Utility model reference",
    [`l.title.docx.${RegisterType.PLANT_BREED}`]: "Plant/Breed reference",
    [`l.title.docx.${RegisterType.SPC}`]: "SPC reference",
    [`l.title.docx.${RegisterType.DESIGN}`]: "Design reference",
    [`l.title.docx.${RegisterType.PARTNERSHIP}`]: "Partnership reference",
    [`l.title.docx.${RegisterType.AGENT}`]: "Agent reference",
    "l.docx.header": "Electronic services portal of Bulgarian Patent Office",
    "l.docx.page": "Page ",
    "l.docx.of": " of ",
    "l.detail.phone": "Phone",
    "l.detail.ca.phone": "Phone (correspondence)",
    "l.detail.email": "Email",
    "l.detail.ca.email": "Email (correspondence)",
    "l.detail.website": "Website",
    "l.detail.ca.website": "Website (correspondence)",
    "l.none": "None",
    "l.format": "Format",
    "l.audio": "Audio file",
    "l.video": "Video file",
    "m.warning.person.cut.results.3":
      "In the table are shown 200 results of total {{0}}. All other IP objects can be viewed by saving the results as an Excel file or by searching by applicant/representative in the main search page.",
    "l.single.design.identifier": "(21) Design identifier",
    "l.single.design.alternateKey": "(11) Registration number",
    "l.single.design.designType": "Design sub-type",
    "l.single.design.status": "Status",
    "l.single.design.name": "(54) Product(s)",
    "l.single.design.nameEn": "(54) Product(s) in English",
    "l.single.design.locarno": "(51) Locarno classes",
    "l.single.design.verbal.element": "Verbal elements",
    "l.single.design.verbal.element.en": "Verbal elements in English",
    "l.table.head.type": "Type",
    [`l.object.${ObjectType.GEO_INDICATION}`]: "Geographical indication",
    [`l.object.${ObjectType.PATENT}`]: "Patent",
    [`l.object.${ObjectType.SPC}`]: "SPC",
    [`l.object.${ObjectType.UTILITY_MODEL}`]: "Utility model",
    [`l.object.${ObjectType.PLANT_BREED}`]: "Plant/Breed",
    [`l.object.${ObjectType.EU_PATENT}`]: "European patent",
    [`l.object.${ObjectType.DESIGN}`]: "Design",
    [`l.object.${ObjectType.MARK}`]: "Mark",
    [`l.object.${ObjectType.SINGLE_DESIGN}`]: "Single design",
    [`l.object.${ObjectType.DIVISIONAL_MARK}`]: "Divisional mark",
    "l.main.patent.title": "Main patent title",
    "l.product.name": "Product name",
    "l.object.ipc": "IPC",
    "l.object.cpc": "CPC",
    "l.object.ipcCode": "IPC",
    "l.object.cpcCode": "CPC",
    "l.searchFilter.ipcSearchType": "IPC search type",
    [`l.searchFilter.ipcSearchType.${IpcSearchType.CODE}`]: "Search by IPC code (free text)",
    [`l.searchFilter.ipcSearchType.${IpcSearchType.AUTOCOMPLETE}`]: "Search by selecting IPCs from list",
    "l.searchFilter.cpcSearchType": "CPC search type",
    [`l.searchFilter.cpcSearchType.${CpcSearchType.CODE}`]: "Search by CPC code (free text)",
    [`l.searchFilter.cpcSearchType.${CpcSearchType.AUTOCOMPLETE}`]: "Search by selecting CPCs from list",
    "l.searchFilter.objectType": "Object type",
    "l.searchFilter.decisionObjectId": "Application number",
    "l.searchFilter.decisionDocumentNumber": "Decision number",
    "l.documentType": "Decision type",
    "l.documentNumber": "Decision number",
    "l.documentDate": "Decision date",
    "l.court.register":
      'Access to the Register of the Administrative Court of Sofia-City with option to search for decisions on the subject "LMGI" ',
    "l.here": "here",
    "l.missing.decision.nbrs": "Not all decisions have numbers",
    "l.decision": "Legal decision",
    "l.panel.decisionData": "Decision data",
    "l.objectType": "Object type",
    "l.legalGroundTypes": "Legal grounds",

    "t.modal.searchFilters": "Search filters",
    "t.modal.selectTableColumns": "Select table columns",
    "t.modal.columns.select.instruction": "Please select the columns to be visible in the table.",
    "l.name.exact.match.section": "Enter an identifier in the format xxxxx-nnn",
    "l.exactMatch.name": "Name",
    "l.exactMatch.exactMatchChecked": "Exact match",
    "l.table.head.number": "№",
    "l.btn.error.report": "Error report",
    "l.table.head.documentNumber": "Document number",
    "l.table.head.applicationDate": "Application date",
    "l.table.head.expiryDate": "Expiration date",
    "l.table.head.representative": "Representative",
    "l.table.head.owner": "Owner",
    "l.table.head.creator": "Creator",
    "l.table.head.file": "",
    ...validationKeysEN.translation,
  },
});

export default messagesEn;
